import styled from "styled-components";
import { Modal } from "antd";
import { tokens } from "../../../assets/tokens";

const { color } = tokens

// className de antd cae en .ant-modal, así que los estilos llegan aunque se pinte en un portal.
// Mismo aspecto que ActionDialog: radio 16, cabecera blanca con título centrado, X arriba a la
// derecha y botones centrados.
export const ModalDraggableStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
  }

  .ant-modal-header {
    padding: 48px 40px 8px;
    border-bottom: none;
    border-radius: 16px 16px 0 0;
  }

  .ant-modal-close {
    top: 16px;
    right: 16px;
  }

  .ant-modal-close-x {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    line-height: 0;
  }

  .ant-modal-body {
    padding: 8px 40px;
    font-family: ${tokens.typography.fontFamily.primary};
  }

  .ant-modal-footer {
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 24px;
    border-top: none;
  }

  .ck-content {
    min-height: 200px;
  }
`

export const TitleStyled = styled.div`
  text-align: center;
  font-family: ${tokens.typography.fontFamily.primary};
  font-weight: 600;
  font-size: 18px;
  line-height: 1.4;
  color: ${color.text.primary};
  cursor: move;
`
